import React from "react"
import PropTypes from "prop-types"

export const DEFAULT_PAGE_SIZE_OPTIONS = [25, 50, 100, 200]

const PageSizeControl = ({
  value,
  onChange,
  options = DEFAULT_PAGE_SIZE_OPTIONS,
  label = "Rows",
}) => (
  <label className="inline-flex items-center gap-2 text-sm text-gray">
    <span>{label}</span>
    <select
      className="border border-gray rounded px-2 py-1 text-darkBrown bg-white"
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
    >
      {options.map((size) => (
        <option key={size} value={size}>
          {size}
        </option>
      ))}
    </select>
  </label>
)

PageSizeControl.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.number),
  label: PropTypes.string,
}

export default PageSizeControl
